var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.category)?_c('article',{staticClass:"d-flex flex-column pt-9 px-5"},[_c('page-grid-internal',{attrs:{"category":_vm.category}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }